export default __webpack_public_path__ + "static/media/information--truck-trailer-lane-straight--g1.5347b556.png";